import * as React from 'react'
import { PageHeader } from '@pushly/aqe/lib/components'
import { classnames } from '@halo/_utils/classnames'
import { observer } from 'mobx-react'
import WhiteLabelsList from '@halo/components/white-labels-list/white-labels-list'
import { noop } from '@pushly/aqe/lib/utils/noop'

@observer
export class WhiteLabels extends React.Component<any, any> {
    public render() {
        return (
            <div className={classnames('page', 'white-labels')}>
                <div className={classnames('page-wrapper')}>
                    <PageHeader title="White-Labels" onTitleSet={noop} />

                    <WhiteLabelsList />
                </div>
            </div>
        )
    }
}
